<div class="import-panel">
	<!-- Main Panel Header -->
	<div class="import-panel-header" (click)="togglePanel()" (keydown.enter)="togglePanel()" tabindex="0" role="button" data-testid="manual-import-panel-toggle">
		<span class="import-panel-title">{{ isTreo() ? 'Import result' : 'Manual Import' }}</span>
		<i [class]="panelExpanded() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
	</div>

	<!-- Main Panel Content -->
	@if (panelExpanded()) {
		<div class="import-panel-content">
			@if (isTreo()) {
				<!-- Treo: open the tabbed import dialog -->
				<button type="button" class="import-open-dialog" [disabled]="!hasEnvironment()" (click)="openImportDialog()" data-testid="manual-import-open-dialog-button">
					<i class="pi pi-upload"></i>
					<span>Import files</span>
				</button>
			} @else {
				<!-- Non-Treo: inline drop zone (unchanged) -->
				<app-file-upload
					uploadMode="import"
					[maxFileSize]="3145728"
					[acceptedTypes]="importAcceptedTypes()"
					[hasEnvironment]="hasEnvironment()"
					(filesUploaded)="onUploadSuccess()"
					(uploadError)="onUploadError($event)"
				/>
			}

			<!-- Hidden upload engine: the dialog's emitted file is pushed here, which drives the
           queue / progress / import banner exactly like a normal drop. -->
			@if (isTreo()) {
				<div class="import-upload-engine">
					<app-file-upload
						#fileUpload
						uploadMode="import"
						[maxFileSize]="3145728"
						[acceptedTypes]="importAcceptedTypes()"
						[hasEnvironment]="hasEnvironment()"
						(filesUploaded)="onUploadSuccess()"
						(uploadError)="onUploadError($event)"
					/>
				</div>
			}
		</div>
	}
</div>

<!-- Treo import dialog -->
@if (isTreo()) {
	<app-import-dialog #importDialog (importFile)="onImportFile($event)" (importFiles)="onImportFiles($event)" (importError)="onUploadError($event)" data-testid="manual-import-dialog" />
}
